import React from 'react'

function HomeSvg() {
  return (
    <>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='24'
        height='24'
        viewBox='0 0 24 24'
        fill='none'
      >
        <path
          opacity='0.4'
          fillRule='evenodd'
          clipRule='evenodd'
          d='M3.13978 8.37009L10.0698 2.8201C11.1298 1.9701 12.8598 1.97008 13.9298 2.83008L20.8598 8.37009C21.6298 8.99009 22.1298 10.3001 21.9698 11.2801L20.6398 19.2401C20.3998 20.6501 19.0298 21.8101 17.5998 21.8101H15V13C15 11.8954 14.1046 11 13 11H11C9.89543 11 9 11.8954 9 13V21.8101H6.39977C4.95977 21.8101 3.59978 20.6601 3.35978 19.2401L2.02978 11.2801C1.85978 10.3001 2.35978 8.99009 3.13978 8.37009Z'
          fill='#E873A8'
        />
        <path
          d='M9 13C9 11.8954 9.89543 11 11 11H13C14.1046 11 15 11.8954 15 13V22H9V13Z'
          fill='#E873A8'
        />
      </svg>
    </>
  )
}

export default HomeSvg
